"use client";
import { jsx as r } from "react/jsx-runtime";
import { forwardRef as a } from "react";
import { Icon as m } from "../icon/icon.js";
import { IconSpinner as c } from "./icon-spinner.js";
import { spinnerStyles as f } from "./spinner.styles.js";
const d = a(
  (n, o) => {
    const { size: e, css: t, title: i = "Loading", onImpact: p = !1, ...s } = n;
    return /* @__PURE__ */ r(
      m,
      {
        "data-c11n-component": "Spinner",
        "data-c11n-version": "10.0.0-alpha.19",
        ref: o,
        size: e,
        title: i || void 0,
        css: { ...f.raw({ onImpact: p }), ...t },
        ...s,
        children: /* @__PURE__ */ r(c, {})
      }
    );
  }
);
d.displayName = "Spinner";
export {
  d as Spinner
};
//# sourceMappingURL=spinner.js.map
